import { Img, List, Text } from "components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { DeleteModal } from "popups/DeleteModal";
// import { AddNewCart } from "popups/AddNewCart"; // Replaced with inline form below
import * as API from "../../../../utils/helper/Enum";
import * as CUSTOM from "../../../../utils/helper/custom";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import { setSnackbar } from "../../../../redux/reducers/snackbar";

const PaymentMathod = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [RemoveCardOpen, setRemoveCardOpen] = React.useState(false);
  const [AddNewCardOpen, setAddNewCardOpen] = React.useState(false);
  const [creditOrDebitCards, setCreditCardList] = useState([]);
  const [deleteId, setDeleteId] = useState(0);

  // Form state for inline add new card
  const [cardHolderName, setCardHolderName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvv, setCvv] = useState("");

  const handelsetRemoveCardOpen = (id = 0) => {
    setDeleteId(id);
    setRemoveCardOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  // Opens inline add card form (no popup overlay needed)
  const handelsetAddNewCardOpen = () => {
    setAddNewCardOpen(true);
    //   document.body.classList.add("overflow-hidden");
    //   document.getElementById("header-box").classList.add("relative");
  };

  // Cancel — go back to saved cards list and reset form fields
  const handelCancelAddCard = () => {
    setAddNewCardOpen(false);
    setCardHolderName("");
    setCardNumber("");
    setExpiryDate("");
    setCvv("");
  };

  /**
   * get credit card details
   */
  const getCardList = async () => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        API.USERS.GET_SAVED_CARD_LIST,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setCreditCardList(response?.data);
      } else {
        setCreditCardList([]);
      }
    } catch (e) {
      setCreditCardList([]);
    }
    dispatch(changeLoader(false));
  };

  /**
   *  Delete payment card by id
   */
  const deleteConfirm = async (type) => {
    if (type == "yes") {
      try {
        let response = await globalRequest(
          `${API.USERS.DELETE_PAYMENT_CARD}/${deleteId}`,
          "delete",
          {},
          {},
          true
        );
        response = response?.data;
        if (response?.status == "SUCCESS") {
          getCardList();
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "success",
            })
          );
        } else {
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "error",
            })
          );
        }
      } catch (e) {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: e?.message,
            snackbarState: "error",
          })
        );
      }
    }
  };

  useState(() => {
    getCardList();
  }, []);

  return (
    <>
      <div className="flex flex-col w-full mb-7">

        {AddNewCardOpen === false && (
          <>
            {/* Header row: title + Add New Card button */}
            <div className="flex items-center justify-between mb-6">
              <Text
                className="text-2xl md:text-[22px] text-black-900 sm:text-xl font-semibold font-['Inter']"
              >
                {t("savedCards")}
              </Text>

              {/* Add New Card button — switches to inline form */}
              <button
                onClick={() => handelsetAddNewCardOpen()}
                className="
                  text-[14px] font-medium text-black-900
                  border border-solid border-gray-300
                  rounded-lg px-4 py-2
                  bg-[white]
                  hover:bg-gray-50
                  transition-colors duration-150
                  cursor-pointer
                  font-['Unbounded']
                "
              >
                {t("AddNewCard")}
              </button>
            </div>

            {/* Card list */}
            <List className="flex flex-col w-full" orientation="vertical">
              <div className="relative w-full flex flex-col gap-3">
                {creditOrDebitCards.length != 0 ? (
                  <>
                    {creditOrDebitCards.map((items) => {
                      return (
                        /* Each card is its own separate bordered card */
                        <div
                          key={`card-id-key-${items?.id}`}
                          className="
                            flex items-center justify-between
                            px-5 py-4
                            bg-[white]
                            border border-solid border-gray-200
                            rounded-xl
                            w-full
                          "
                        >
                          {/* Card logo + masked number */}
                          <div className="flex items-center gap-4">
                            <Img
                              className="h-7 object-contain"
                              src={CUSTOM.cardTypeLogo(items?.type)}
                              alt={items?.type}
                            />
                            <Text
                              className="text-[18px] text-black-900 font-medium font-['Inter']"
                            >
                              {t("cardEndingIn")}{" "}
                              <span className="tracking-widest">••••</span>{" "}
                              {items?.cardNumber?.slice(-4)}
                            </Text>
                          </div>

                          {/* Delete icon */}
                          <Img
                            className="h-6 w-6 cursor-pointer opacity-50 hover:opacity-80 transition-opacity duration-150"
                            src="/images/deleteIcon.svg"
                            alt="delete"
                            onClick={() => {
                              handelsetRemoveCardOpen(items?.id);
                            }}
                          />
                        </div>
                      );
                    })}
                  </>
                ) : null}
              </div>
              {/* <div className="bg-light_blue-50 flex items-center justify-between py-3 px-5 rounded w-full">
                <div className="flex items-center justify-start gap-4">
                  <Img
                    className="h-8 w-8"
                    src="/images/img_computer_black_900.svg"
                    alt="computer"
                  />
                  <Text
                    className="text-base text-black-900"
                    size="txtnunitoMedium16"
                  >
                    {t("applePay")}
                  </Text>
                </div>
                <Text
                  className="text-center text-pink-800 text-sm w-auto cursor-pointer py-2 px-3"
                  size="txtnunitoMedium14"
                >
                  {t("link")}
                </Text>
              </div>
              <div className="bg-light_blue-50 flex items-center justify-between py-3 px-5 rounded w-full">
                <div className="flex items-center justify-start gap-4">
                  <Img
                    className="h-8 w-8"
                    src="/images/img_computer_black_900.svg"
                    alt="computer"
                  />
                  <Text
                    className="text-base text-black-900"
                    size="txtnunitoMedium16"
                  >
                    {t("buyNowPayLater")}
                  </Text>
                </div>
                <Text
                  className="text-center text-pink-800 text-sm w-auto cursor-pointer py-2 px-3"
                  size="txtnunitoMedium14"
                >
                  {t("link")}
                </Text>
              </div> */}
            </List>
          </>
        )}

        {AddNewCardOpen === true && (
          <div className="flex flex-col w-full">

            {/* Form title */}
            <Text
              className="text-[20px] md:text-[16px] text-black-900 sm:text-xl font-semibold mb-6 font-['Inter']"
            >
              {t("addingNewCard")}
            </Text>

            {/* Card Holder Name */}
            <div className="flex flex-col gap-1 mb-4">
              <label className="text-[14px] font-medium leading-[16px] font-['Inter'] text-[var(--Blacks-300,#6D737E)]">
                {t("cardHolderName")} <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder={t("enterYourCardName")}
                value={cardHolderName}
                onChange={(e) => setCardHolderName(e.target.value)}
                className="
                figma-input
                  w-full border border-solid border-gray-300
                  rounded-lg px-4 py-3
                  text-[14px] text-black-900 font-['Inter']
                  placeholder:text-[14px]
                  placeholder:font-normal
                  placeholder:leading-[20px]
                  placeholder:font-['Inter']
                  placeholder:text-[var(--Blacks-100,#A2A6AE)]
                  bg-[white]
                  outline-none focus:border-gray-500
                  transition-colors duration-150
                "
              />
            </div>

            {/* Card Number */}
            <div className="flex flex-col gap-1 mb-4">
              <label className="text-[14px] font-medium leading-[16px] font-['Inter'] text-[var(--Blacks-300,#6D737E)]">
                {t("cardNumber")} <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="XXXX XXXX XXXX XXXX"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
                maxLength={19}
                className="
                figma-input
                  w-full border border-solid border-gray-300
                  rounded-lg px-4 py-3 text-sm text-black-900
                  placeholder-gray-400 bg-[white]
                  outline-none focus:border-gray-500
                  transition-colors duration-150
                "
              />
            </div>

            {/* Expiration Date + CVV — side by side */}
            <div className="flex items-start gap-4 mb-6 sm:flex-col">
              <div className="flex flex-col gap-1 flex-1 sm:w-full">
                <label className="text-[14px] font-medium leading-[16px] font-['Inter'] text-[var(--Blacks-300,#6D737E)]">
                  {t("expirationDate")} <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="MM/YY"
                  value={expiryDate}
                  onChange={(e) => setExpiryDate(e.target.value)}
                  maxLength={5}
                  className="
                  figma-input
                    w-full border border-solid border-gray-300
                    rounded-lg px-4 py-3 text-sm text-black-900
                    placeholder-gray-400 bg-[white]
                    outline-none focus:border-gray-500
                    transition-colors duration-150
                  "
                />
              </div>
              <div className="flex flex-col gap-1 flex-1 sm:w-full">
                <label className="text-sm font-medium text-black-900">
                  {t("cvv")} <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  placeholder="•••"
                  value={cvv}
                  onChange={(e) => setCvv(e.target.value)}
                  maxLength={4}
                  className="
                  figma-input
                    w-full border border-solid border-gray-300
                    rounded-lg px-4 py-3 text-sm text-black-900
                    placeholder-gray-400 bg-[white]
                    outline-none focus:border-gray-500
                    transition-colors duration-150
                  "
                />
              </div>
            </div>

            {/* Save Card button */}
            <div className="flex flex-row p-2 justify-between items-center w-full">

            {/* Cancel button — goes back to saved cards list */}
            <div className="p-2 w-full">
            <button
              onClick={() => handelCancelAddCard()}
              className="
                w-full py-4 rounded-full
                border border-solid border-gray-300
                bg-[white] hover:bg-gray-50
                text-black-900 text-base font-medium
                transition-colors duration-150
                cursor-pointer mb-4
              "
            >
              {t("cancel")}
            </button>
            </div>
            <div className="p-2 w-full">
            <button
              className="
                w-full py-4 rounded-full
                bg-[#8B1A4A] hover:bg-[#7a1640]
                text-[white] text-base font-medium
                transition-colors duration-150
                cursor-pointer mb-3
              "
            >
              {t("saveCard")}
            </button>
            </div>
            </div>

            {/* Secure payment note */}
            <p className="text-center text-[14px] text-gray-500 font-['Inter']">
               {t("100SecurePaymentsPoweredByRabbitHole")}
            </p>

          </div>
        )}

      </div>

      {/* AddNewCart popup — kept as comment (replaced by inline form above) */}
      {/* {AddNewCardOpen === true ? (
        <AddNewCart
          closepopup={setAddNewCardOpen}
          modalTopIcon="images/modal-celebration-icon.svg"
          OccasionTitle={t("addNewOccasion")}
          OccasionParagraph={t("enterBelowDetailsToAddANewOccasionDot")}
        />
      ) : null} */}

      {RemoveCardOpen === true ? (
        <DeleteModal
          deleteTitle={"Delete Card"}
          deleteParagraph={t("deleteCardAlert")}
          deleteConfirm={deleteConfirm}
          closepopup={setRemoveCardOpen}
        />
      ) : null}
    </>
  );
};

export default PaymentMathod;
